<template>
    <SubmenuGrid :items="items" :show-count="false" />
</template>

<script>
import SubmenuGrid from "@/components/SubmenuGrid";

export default {
    name: "PortalSchoolDisciplineManagementSubMenuvueSubmenu",
    components: { SubmenuGrid },
    data() {
        return {
            items: [
            {
                to: "#",
                title: "Behaviour Records",
                description: "Record and review student behaviour and conduct incidents.",
                icon: "fa fa-folder"
            },
            {
                to: "#",
                title: "Warnings",
                description: "Issue and track formal warnings for student conduct.",
                icon: "fa fa-folder"
            },
            {
                to: "#",
                title: "Suspension",
                description: "Manage student suspensions and related case details.",
                icon: "fa fa-folder"
            },
            {
                to: "#",
                title: "Rewards",
                description: "Recognize positive conduct and record student rewards.",
                icon: "fa fa-folder"
            },
            {
                to: "#",
                title: "Incident Reports",
                description: "Document incidents and follow up on reported cases.",
                icon: "fa fa-folder"
            }
            ]
        };
    }
};
</script>
